export function getToken(client, type = 'idToken') {
    const state = client.getState();
    return state.tokens ? state.tokens[type] : null;
}
// update tokens upon automatic token refresh
export function updateTokens(client, newTokens) {
    const state = client.getState();
    const existingTokens = state.tokens;
    const tokens = {
        ...existingTokens,
        ...newTokens,
    };
    client.replaceState({
        ...state,
        tokens,
    });
}
// explicitly clear Tokens
export function clearTokens(client) {
    const state = client.getState();
    client.replaceState({
        ...state,
        tokens: undefined,
    });
}
